/*
 * @Descripttion: 商家中心接口
 * @version: 
 * @Author: loong
 * @Date: 2022-09-22 16:26:31
 * @LastEditors: loong
 * @LastEditTime: 2022-10-11 16:39:29
 */
import * as config from "./config";
// 交易信息
export const tradeInfoMSG = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/tradeInfo/20';
// 商品需求信息
export const demandInfoMSG = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/demandInfo/20';
// 供应信息
export const goodSupplierListMSG = (config.flag ? config.proPrefix : config.clientUrlAPI) + '/api/goodSupplierList/20';

